import { Separator } from '@swyftx/aviary/atoms/Seperator';

import { cn } from '@shared/utils/lib/ui';

import { SideBarMobileFooter, SideBarMobileHeader } from '../components';
import Items from '../components/Items';
import { useAppSideBar } from '../useAppSideBar';

export default function MobileSidebar() {
  const { state } = useAppSideBar();
  const { onCloseAppBar } = useAppSideBar();

  return (
    <>
      <div className='absolute h-full'>
        <aside
          className={cn(
            'relative z-[90] h-full w-[90vw] overflow-auto bg-color-background-surface-primary transition-transform ease-in',
            state === 'docked' ? 'translate-x-0' : 'translate-x-[-100%]',
          )}
        >
          <SideBarMobileHeader />
          <div className='grid gap-8 px-8'>
            <Separator />
            <Items isMobile />
          </div>
          <SideBarMobileFooter />
        </aside>
      </div>
      {state === 'docked' && (
        <div
          className='absolute left-0 top-0 z-20 h-full w-full cursor-pointer bg-black opacity-30 md:hidden'
          onClick={onCloseAppBar}
        />
      )}
    </>
  );
}
